/* sp-mini-slider.js — minimal jQuery `.slider()` replacement for the diamond PDP
 * carat size-preview slider. Implements ONLY the jQuery UI Slider API used by
 * diamonddetail.js:  .slider({min,max,step,create,slide}) | .slider('value') | .slider('value', n)
 * Pointer + touch + keyboard. Replaces ~283KB of jQuery UI with ~3KB.
 * If real jQuery UI is ever present, this no-ops (won't clobber). */
(function () {
  function register($) {
    if (!$ || $.fn.slider) return; // don't override real jQuery UI

    $.fn.slider = function (opt, val) {
      // getter: .slider('value')
      if (opt === 'value' && arguments.length === 1) {
        var d = this.data('spSlider');
        return d ? d.value : undefined;
      }
      return this.each(function () {
        var el = this, $el = $(el), st = $el.data('spSlider');

        // setter: .slider('value', n) — moves handle, no slide event (matches jQuery UI)
        if (opt === 'value') { if (st) st.set(parseFloat(val), false); return; }

        // init: .slider({ min, max, step, create, slide })
        if (st) return; // re-init guard: don't stack listeners on double init
        var o = $.extend({ min: 0, max: 100, step: 1 }, opt || {});
        var handle = el.querySelector('.ui-slider-handle');
        if (!handle) {
          handle = document.createElement('div');
          handle.className = 'ui-slider-handle';
          el.appendChild(handle);
        }
        var state = { value: (o.value != null ? o.value : o.min) };

        function clamp(v) {
          if (isNaN(v)) v = o.min;
          v = Math.round((v - o.min) / o.step) * o.step + o.min;
          v = Math.max(o.min, Math.min(o.max, v));
          return Math.round(v * 1000) / 1000;
        }
        function pctOf(v) { return (v - o.min) / (o.max - o.min) * 100; }
        function render() { handle.style.left = pctOf(state.value) + '%'; }
        function set(v, fire) {
          state.value = clamp(v);
          render();
          handle.setAttribute('aria-valuenow', state.value);
          if (fire && typeof o.slide === 'function') o.slide({}, { value: state.value });
        }
        state.set = set;
        $el.data('spSlider', state);

        function valFromX(cx) {
          var r = el.getBoundingClientRect();
          if (!r.width) return state.value;
          var t = Math.max(0, Math.min(1, (cx - r.left) / r.width));
          return o.min + t * (o.max - o.min);
        }
        var dragging = false;
        function clientX(e) {
          return e.clientX != null ? e.clientX
            : (e.touches && e.touches[0] ? e.touches[0].clientX : null);
        }
        function down(e) {
          dragging = true;
          var cx = clientX(e); if (cx != null) set(valFromX(cx), true);
          try { if (el.setPointerCapture && e.pointerId != null) el.setPointerCapture(e.pointerId); } catch (x) {}
          e.preventDefault();
        }
        function move(e) { if (!dragging) return; var cx = clientX(e); if (cx != null) set(valFromX(cx), true); }
        function up() { dragging = false; }

        if (window.PointerEvent) {
          el.addEventListener('pointerdown', down);
          document.addEventListener('pointermove', move);
          document.addEventListener('pointerup', up);
        } else {
          el.addEventListener('mousedown', down);
          document.addEventListener('mousemove', move);
          document.addEventListener('mouseup', up);
          el.addEventListener('touchstart', down, { passive: false });
          document.addEventListener('touchmove', move, { passive: false });
          document.addEventListener('touchend', up);
        }

        // keyboard a11y on the handle
        handle.setAttribute('role', 'slider');
        handle.setAttribute('tabindex', handle.getAttribute('tabindex') || '0');
        handle.setAttribute('aria-valuemin', o.min);
        handle.setAttribute('aria-valuemax', o.max);
        handle.addEventListener('keydown', function (e) {
          var d = 0;
          if (e.key === 'ArrowRight' || e.key === 'ArrowUp') d = o.step;
          else if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') d = -o.step;
          else if (e.key === 'Home') { set(o.min, true); e.preventDefault(); return; }
          else if (e.key === 'End') { set(o.max, true); e.preventDefault(); return; }
          if (d) { set(state.value + d, true); e.preventDefault(); }
        });

        // initial render + create() (jQuery UI defaults value to min when unspecified)
        render();
        handle.setAttribute('aria-valuenow', state.value);
        if (typeof o.create === 'function') o.create.call(el);
      });
    };
  }

  if (window.jQuery) register(window.jQuery);
  else {
    var n = 0, t = setInterval(function () {
      if (window.jQuery || n++ > 100) { clearInterval(t); if (window.jQuery) register(window.jQuery); }
    }, 50);
  }
})();
